import React from "react";
import Marquee from "react-fast-marquee";
import { CLIENT_LOGOS } from "../data/site";

export const ClientCarousel = () => {
  return (
    <section className="py-20 bg-white border-y border-slate-200" data-testid="clients-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <p className="overline">Our Clients</p>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-blue mt-3">
              Trusted by India's leading energy &amp; gas majors.
            </h2>
          </div>
          <p className="text-sm text-slate-600 max-w-md">
            We are proud to associate with India's leading public-sector and private gas operators.
          </p>
        </div>
      </div>

      <div className="marquee-fade">
        <Marquee speed={40} gradient={false} pauseOnHover>
          {CLIENT_LOGOS.concat(CLIENT_LOGOS).concat(CLIENT_LOGOS).map((c, i) => (
            <div
              key={i}
              title={c.fullName}
              className="mx-6 md:mx-10 flex items-center justify-center h-28 w-48 bg-white border border-slate-200 rounded-sm p-4 hover:border-brand-orange transition-colors"
              data-testid={`client-logo-${i}`}
            >
              <img
                src={c.logo}
                alt={c.fullName}
                className="max-h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
